import fs from 'node:fs';
import { logToConsole } from './serverLogger.ts';

export function preventFastSpans(event) {
  if (event.spans) {
    event.spans = event.spans.filter(span => {
      const durationMs = (span.timestamp - span.start_timestamp) * 1000;
      const keep = durationMs >= 100;
      return keep;
    });
  }
  return event;
}

const SENTRY_TEMP_CONFIG_FILE_PATH = './server/sentryTempConfig.json';
export function readTempSentryConfig() {
  let tempConfig = {};
  try {
    const configFile = fs.readFileSync(SENTRY_TEMP_CONFIG_FILE_PATH, 'utf8');
    tempConfig = JSON.parse(configFile);
    logToConsole({ logLevel: 'INFO', message: `Temporary Sentry Config: ${JSON.stringify(tempConfig)}` });
  } catch {
    // do nothing
  }
  return tempConfig;
}
export function writeTempSentryConfig(newTempSentryConfig: object) {
  const newTempSentryConfigJson = JSON.stringify(newTempSentryConfig, null, 2);
  fs.writeFileSync(SENTRY_TEMP_CONFIG_FILE_PATH, newTempSentryConfigJson);
  logToConsole({
    logLevel: 'INFO',
    message: `Temporary Sentry Config successfully written: ${newTempSentryConfigJson}`
  });
}
